import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function FloatingActions() {
  const { config } = useSite();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const wa = (config?.whatsapp || "").replace(/\D/g, "");
  const showWa = config?.whatsapp_fab_enabled !== false && wa;

  return (
    <>
      {show && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-24 right-6 w-11 h-11 rounded-full bg-foreground text-background shadow-xl hover:scale-110 transition-transform z-40 flex items-center justify-center"
          aria-label="Volver arriba"
          data-testid="back-to-top"
        >
          <ArrowUp className="w-5 h-5" />
        </button>
      )}
      {showWa && (
        <a
          href={`https://wa.me/${wa}`}
          target="_blank"
          rel="noreferrer"
          className="fixed bottom-6 right-6 w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl hover:scale-110 transition-transform z-40 flex items-center justify-center animate-pulse-slow"
          aria-label="WhatsApp"
          data-testid="whatsapp-fab"
        >
          <svg viewBox="0 0 24 24" className="w-7 h-7" fill="currentColor"><path d="M20.52 3.48A11.93 11.93 0 0 0 12.04 0C5.49 0 .17 5.32.17 11.87a11.8 11.8 0 0 0 1.59 5.94L0 24l6.34-1.66a11.86 11.86 0 0 0 5.7 1.45h.01c6.55 0 11.87-5.32 11.87-11.87a11.8 11.8 0 0 0-3.4-8.44ZM12.05 21.3h-.01a9.85 9.85 0 0 1-5.02-1.37l-.36-.21-3.76.98 1-3.66-.23-.38a9.79 9.79 0 0 1-1.5-5.21c0-5.44 4.43-9.86 9.88-9.86 2.64 0 5.12 1.03 6.99 2.9a9.79 9.79 0 0 1 2.89 6.97c0 5.44-4.43 9.84-9.88 9.84Zm5.4-7.37c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.66.15s-.76.96-.93 1.16c-.17.2-.34.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.65-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.6-.91-2.18-.24-.58-.49-.5-.66-.51l-.56-.01c-.2 0-.51.07-.78.37s-1.03 1-1.03 2.45 1.05 2.84 1.2 3.04c.15.2 2.07 3.16 5.02 4.43.7.3 1.25.48 1.68.62.7.22 1.34.19 1.85.12.56-.08 1.75-.71 2-1.4.25-.69.25-1.27.18-1.4-.07-.12-.27-.2-.57-.34Z"/></svg>
        </a>
      )}
    </>
  );
}
